module.exports = __webpack_public_path__ + "img/lms-dashboard-fragentutor.92d27828.png";